// Helpers de fecha/hora para el hincha. Muestran en la zona horaria del dispositivo.

const DAYS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
const MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

// "2026-06-11T19:00:00+00:00" -> "jue 11 jun · 16:00" (hora local del usuario).
export function formatKickoff(iso: string | null): string {
  if (!iso) return 'A definir';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return 'A definir';
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${DAYS[d.getDay()]} ${d.getDate()} ${MONTHS[d.getMonth()]} · ${hh}:${mm}`;
}

// Solo la hora local: "16:00".
export function formatTime(iso: string | null): string {
  if (!iso) return '--:--';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '--:--';
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

// Fecha larga en español: "jueves 11 de junio". Para encabezados de calendario.
export function formatDateLong(iso: string | null): string {
  if (!iso) return 'Fecha a definir';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return 'Fecha a definir';
  const s = d.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' });
  return s.charAt(0).toUpperCase() + s.slice(1);
}

// Clave de día local (YYYY-MM-DD) para agrupar por fecha de calendario.
export function dayKey(iso: string | null): string {
  if (!iso) return 'tbd';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return 'tbd';
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// Cuenta regresiva corta hasta el inicio: "en 2 d", "en 3 h", "en 12 min", "¡ya!".
export function countdown(iso: string | null): string {
  if (!iso) return '';
  const diff = new Date(iso).getTime() - Date.now();
  if (diff <= 0) return '¡ya!';
  const min = Math.round(diff / 60000);
  if (min < 60) return `en ${min} min`;
  const h = Math.round(min / 60);
  if (h < 24) return `en ${h} h`;
  return `en ${Math.round(h / 24)} d`;
}
